/*
 * Barnabas prestige header chrome — scroll morph for smooth page continuity.
 * - Transparent over hero → frosted glass when scrolled
 * - Announcement soft-collapses into the header glass
 * - Subtle hide-on-scroll-down / reveal-on-scroll-up (reduced-motion safe)
 * - Swaps black-box logo for transparent tree cutout (no frame)
 * - Centers a floating italic Barnabas wordmark in the header (separate from logo)
 */
(function () {
  'use strict';

  var root = document.documentElement;
  var body = document.body;
  if (!body) return;
  var isIndex = body.classList.contains('template--index');
  var isCollection = body.classList.contains('template--collection');
  var isProduct = body.classList.contains('template--product');
  var isPage = body.classList.contains('template--page');
  if (!isIndex && !isCollection && !isProduct && !isPage) return;
  if (!document.querySelector('.bbw[data-header-overlap-compatible], .bbch[data-header-overlap-compatible], .bbc[data-header-overlap-compatible], .bbp[data-header-overlap-compatible], .bbherb[data-header-overlap-compatible], .bboil[data-header-overlap-compatible], .bbsh[data-header-overlap-compatible], .bbculture[data-header-overlap-compatible]')) return;

  body.setAttribute('data-bb-chrome', 'true');

  var logoUrl = (window.__bbChrome && window.__bbChrome.logoUrl) || '';

  function enhanceBrandMark(img) {
    if (!img) return;
    var link = img.closest('.small-logo--root') || img.parentElement;
    if (!link) return;

    var frame = img.closest('.bb-brand__frame');
    if (frame && frame.parentNode) {
      frame.parentNode.insertBefore(img, frame);
      frame.remove();
    }

    link.querySelectorAll('.bb-brand__word').forEach(function (el) {
      el.remove();
    });

    if (img.getAttribute('data-bb-logo') !== 'tree') {
      if (logoUrl) {
        img.src = logoUrl;
        img.removeAttribute('srcset');
        img.style.background = 'transparent';
      }
      img.setAttribute('data-bb-logo', 'tree');
      img.setAttribute('alt', 'Barnabas');
    }

    img.classList.add('bb-brand__mark');
  }

  function injectCenterWordmark() {
    var wrapper = document.querySelector('.header--wrapper');
    if (!wrapper || wrapper.querySelector('.bb-brand__crest')) return;

    var crest = document.createElement('div');
    crest.className = 'bb-brand__crest';
    var inner = document.createElement('a');
    inner.href = '/';
    inner.className = 'bb-brand__crestLink';
    inner.textContent = 'Barnabas';
    crest.appendChild(inner);

    var logo = wrapper.querySelector('.header--logo');
    if (logo && logo.nextSibling) {
      wrapper.insertBefore(crest, logo.nextSibling);
    } else if (logo) {
      wrapper.appendChild(crest);
    } else {
      wrapper.appendChild(crest);
    }
  }

  document.querySelectorAll('.header--logo img').forEach(enhanceBrandMark);
  injectCenterWordmark();

  // Reveal immediately so logo never stays opacity:0 if rAF is throttled
  // (background tabs / preview iframes often stall requestAnimationFrame).
  body.setAttribute('data-bb-brand-ready', 'true');

  var ticking = false;
  var scrolled = null;
  var compact = null;
  var threshold = 48;
  var compactAt = 120;

  function syncAnnouncementHeight() {
    var bar = document.querySelector('.announcement--root');
    if (!bar) return;
    var height = Math.ceil(bar.getBoundingClientRect().height);
    if (height < 1) return;
    root.style.setProperty('--announcement--height', height + 'px');
    root.style.setProperty('--bb-announce-h', height + 'px');
  }

  function apply() {
    var y = window.scrollY || 0;
    var nextScrolled = y > threshold;
    var nextCompact = y > compactAt;

    if (nextScrolled !== scrolled) {
      scrolled = nextScrolled;
      body.setAttribute('data-bb-scrolled', scrolled ? 'true' : 'false');
    }

    if (nextCompact !== compact) {
      compact = nextCompact;
      body.setAttribute('data-bb-chrome-compact', compact ? 'true' : 'false');
    }

    body.setAttribute('data-bb-chrome-hide', 'false');

    var progress = Math.min(1, Math.max(0, y / compactAt));
    root.style.setProperty('--bb-chrome-blend', progress.toFixed(3));
    ticking = false;
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(apply);
  }

  apply();
  syncAnnouncementHeight();
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () {
    syncAnnouncementHeight();
    onScroll();
  }, { passive: true });
  window.addEventListener('load', syncAnnouncementHeight);
})();
